// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import PortalComponent, { createContainer } from "./portal.component";
import clsx from "clsx";
import { ButtonComponent } from "../button";
import { useIntl } from "react-intl";
import { ModalXIcon } from "../../../../resources/icons/interface";

const MODAL_CONTAINER_ID = "modal-container-id";

type Props = {
  onClose?: () => void;
  children?: JSX.Element | string;
  buttons?: JSX.Element;
  isFull?: boolean;
  isNeedHeightFit?: boolean;
  withoutButton?: boolean;
  classNames?: string;
  isPriorityHeader?: boolean;
  isNeedBaseCloseButton?: boolean;
  isNeedBaseXButton?: boolean;
  isScrollableContent?: boolean;
  classNameButtons?: string;
  containerPosition?:
    | "center"
    | "top"
    | "bottom"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right";
  modalTitle?: JSX.Element;
};
export const ModalWithPortalComponent = (props: Props) => {
  const {
    onClose,
    children,
    buttons,
    isFull = false,
    withoutButton = false,
    classNames,
    isPriorityHeader = true,
    isNeedHeightFit = false,
    isNeedBaseCloseButton = true,
    isNeedBaseXButton = true,
    classNameButtons,
    containerPosition = "center",
    modalTitle,
    isScrollableContent = true,
  } = props;
  const intl = useIntl();
  const rootRef = useRef<HTMLDivElement>(null);

  const [isMounted, setMounted] = useState(false);

  useEffect(() => {
    createContainer({ id: MODAL_CONTAINER_ID });
    setMounted(true);
  }, []);

  useEffect(() => {
    const handleEscapePress = (event: KeyboardEvent) => {
      if (event.key === "Escape" && onClose) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEscapePress);
    return () => window.removeEventListener("keydown", handleEscapePress);
  }, [onClose]);

  useBodyScrollLock(!!isMounted);

  const positionClasses = {
    center: "items-center justify-center",
    top: "items-start justify-center",
    bottom: "items-end justify-center",
    "top-left": "items-start justify-start",
    "top-right": "items-start justify-end",
    "bottom-left": "items-end justify-start",
    "bottom-right": "items-end justify-end",
  };

  return isMounted ? (
    <PortalComponent id={MODAL_CONTAINER_ID}>
      <div
        className={clsx(
          "fixed inset-0 flex",
          positionClasses[containerPosition],
          isPriorityHeader ? "z-40" : "z-[2000]",
        )}
        ref={rootRef}
      >
        <div
          className="bg-black opacity-50 absolute inset-0"
          onClick={onClose}
        ></div>
        <div
          className={clsx(
            "bg-white p-6 z-10 relative flex flex-col",
            isFull && "m-8 w-full",
            isFull && (isNeedHeightFit ? "h-fit" : "h-[90dvh]"),
            classNames ? classNames : "rounded-lg",
          )}
        >
          {isNeedBaseXButton && (
            <div
              className="absolute top-0 right-0 p-6 cursor-pointer z-20"
              onClick={onClose}
            >
              <ModalXIcon className="w-4 fill-primary-active" />
            </div>
          )}

          {/* Контент модалки */}
          {modalTitle && (
            <h4 className={"text-base font-medium mb-4"}>{modalTitle}</h4>
          )}
          <div
            className={clsx(
              isScrollableContent
                ? "overflow-auto max-h-[60dvh] mb-4"
                : "h-full",
            )}
          >
            {children}
          </div>

          {!withoutButton && (
            <div
              className={clsx(
                classNameButtons
                  ? classNameButtons
                  : "flex justify-end items-center gap-8 mt-6",
              )}
            >
              <div id={"modal-buttons"}>{buttons}</div>
              {isNeedBaseCloseButton && (
                <ButtonComponent
                  className="p-2 bg-primary-active text-white"
                  onClick={onClose}
                >
                  {intl.formatMessage({
                    id: "individualPlan.list.button.close",
                  })}
                </ButtonComponent>
              )}
            </div>
          )}
        </div>
      </div>
    </PortalComponent>
  ) : null;
};

export const useBodyScrollLock = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) return undefined; // если модалка закрыта — ничего не делаем

    const scrollY = window.scrollY;
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add("modal-open");

    return () => {
      const scrollTop = -parseInt(document.body.style.top || "0", 10);
      document.body.classList.remove("modal-open");
      document.body.style.top = "";
      window.scrollTo(0, scrollTop); // возвращаем скролл на место
    };
  }, [isOpen]);
};
